import { Card } from "@mui/material";

import PositionsTable from "./PositionsTable/Table";
import ResultsHeader from "./ResultsHeader";

// ----------------------------------------------------------------------

export const PositionsTableCard = () => {
	return (
		<Card
			sx={{
				maxWidth: 1300,
				width: "100%",
				py: 2,
				mb: 10,
				mt: 3
			}}
		>
			<ResultsHeader />
			<PositionsTable />
		</Card>
	);
};

export default PositionsTableCard;
